import { Text } from "@clipboard-health/ui-components";
import { useMemo } from "react";

import { formatDayOfMonthWithDayName } from "../../utils/formatDayOfMonthWithDayName";

export interface ShiftDateProps {
  shiftStartDate: Date;
  workplaceTimezone: string;
}

export function ShiftDate(props: ShiftDateProps) {
  const { shiftStartDate, workplaceTimezone } = props;

  const formattedDate = useMemo(
    () => formatDayOfMonthWithDayName(shiftStartDate, { timezone: workplaceTimezone }),
    [shiftStartDate, workplaceTimezone]
  );

  return (
    <Text semibold variant="h5">
      {formattedDate}
    </Text>
  );
}
